module.exports = __webpack_public_path__ + "static/media/adLeads_preview.7d2080a6.PNG";